// Performance Summary Chart
export const SET_PERFORMANCE_SUMMARY_CHART = 'SET_PERFORMANCE_SUMMARY_CHART';
export const CLEAR_PERFORMANCE_SUMMARY_CHART = 'CLEAR_PERFORMANCE_SUMMARY_CHART';